import { createContext, useContext, type ReactNode } from "react";

import type { LeadFilterMode } from "./leadFilters";

type LeadFilterContextValue = {
  mode: LeadFilterMode;
  setMode: (mode: LeadFilterMode) => void;
};

const LeadFilterContext = createContext<LeadFilterContextValue>({
  mode: "active",
  setMode: () => undefined,
});

export const LeadFilterProvider = ({
  mode,
  setMode,
  children,
}: LeadFilterContextValue & { children: ReactNode }) => (
  <LeadFilterContext.Provider value={{ mode, setMode }}>
    {children}
  </LeadFilterContext.Provider>
);

export const useLeadFilterContext = () => useContext(LeadFilterContext);
